module.exports = __webpack_public_path__ + "assets/fonts/Georgia-Bold -Italic.63a604a5.ttf";